<article class="card">
  <section class="team-name">
    <svg class="sprite icon">
      <use xlink:href="#external-teams"></use>
    </svg>
    {{ team.label}}
  </section>

  <section class="team-email">
    {{  contactEmail }}
  </section>
  <section class="active-jobs">Active jobs: <span class="count">{{ team.numberOfActiveActions }}</span></section>
</article>
